export const createCollectionSlice = set => ({
  collection: null,
  setCollection: value => set(() => ({ collection: value })),

  collections: [],
  setCollections: values => set(() => ({ collections: values })),

  collectionsRef: [],
  setCollectionsRef: values => set(() => ({ collectionsRef: values })),

  collectionsFilter: { search: '', tags: [] },
  setCollectionsFilter: value =>
    set(state => ({
      collectionsFilter: { ...state.collectionsFilter, ...value }
    })),
  selectedCollectionExercises: [],

  collectionDraggable: false,
  setCollectionDraggable: value => set(() => ({ collectionDraggable: value }))
});
